var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIdentification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.75C16.7574 13.75 15.75 14.7574 15.75 16V20.75C15.75 21.1642 16.0858 21.5 16.5 21.5C16.9142 21.5 17.25 21.1642 17.25 20.75V16C17.25 15.5858 17.5858 15.25 18 15.25C18.4142 15.25 18.75 15.5858 18.75 16V16.5433C18.75 16.9575 19.0858 17.2933 19.5 17.2933C19.9142 17.2933 20.25 16.9575 20.25 16.5433V16C20.25 14.7574 19.2426 13.75 18 13.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21.5C19.9142 21.5 20.25 21.1642 20.25 20.75V19.1442C20.25 18.7299 19.9142 18.3942 19.5 18.3942C19.0858 18.3942 18.75 18.7299 18.75 19.1442V20.75C18.75 21.1642 19.0858 21.5 19.5 21.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.75C14.4142 22.75 14.75 22.4142 14.75 22V18.75C14.75 18.3358 14.4142 18 14 18C13.5858 18 13.25 18.3358 13.25 18.75V22C13.25 22.4142 13.5858 22.75 14 22.75Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.25C15.6308 11.25 13.6668 12.9845 13.3084 15.2529C13.2438 15.662 13.5858 16 14 16C14.4142 16 14.7411 15.6596 14.8355 15.2563C15.1718 13.8198 16.4609 12.75 18 12.75C19.7949 12.75 21.25 14.2051 21.25 16V22C21.25 22.4142 21.5858 22.75 22 22.75C22.4142 22.75 22.75 22.4142 22.75 22V16C22.75 13.3766 20.6234 11.25 18 11.25Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1977 12H4C2.89543 12 2 12.8954 2 14C2 18.4183 5.58172 22 10 22C10.6011 22 11.1868 21.9337 11.75 21.808V18.75C11.75 18.0411 12.0778 17.4088 12.5902 16.9964C12.0449 16.5612 11.6925 15.869 11.8268 15.0188C12.0065 13.8814 12.4925 12.846 13.1977 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIdentification);
export default __webpack_public_path__ + "static/media/user-identification.5fb1d2bc59a969e8333e449974674b5c.svg";
export { ForwardRef as ReactComponent };